module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("Julie D. Jones was born in Bovey Tracey on the edge of Dartmoor and grew up near Kingsbridge in the South Hams in Devon. After finishing school Julie spent some time as an au pair in Bavaria. Graduating from The Gloucestershire Royal Hospital as a nurse, she emigrated to Australia working as a Nurse and also in the Music Industry. "), _c('em', [_vm._v("Aftershock")]), _vm._v(" is her fourth novel following on from the release in 2017 of "), _c('em', [_vm._v("Bound by Polaris")]), _vm._v(", "), _c('em', [_vm._v("Devil’s Realm")]), _vm._v(" in 2019 and "), _c('em', [_vm._v("Conspiracy of Souls")]), _vm._v(" in 2021. Julie is a classically trained flautist and enjoys sailing and horse riding.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0